// src/pages/About.js
import React from "react";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min"; // JS de Bootstrap

export default function About() {
  const ADDRESS =
    "Cité Maman N’DANIDA, à côté de la pharmacie de la Cité — Avénou, 08 BP 8213 Lomé 08, Lomé (Togo)";
  const MAP_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;
  const MAP_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;

  const PHONES = [
    { label: "(+228) 98 11 05 55", href: "tel:+22898110555" },
    { label: "(+228) 90 11 92 55", href: "tel:+22890119255" },
  ];

  const HOURS = [
    { d: "Lundi", h: "07:00 — 18:00" },
    { d: "Mardi", h: "07:00 — 18:00" },
    { d: "Mercredi", h: "07:00 — 18:00" },
    { d: "Jeudi", h: "07:00 — 18:00" },
    { d: "Vendredi", h: "07:00 — 18:00" },
    { d: "Samedi", h: "Fermé" },
    { d: "Dimanche", h: "Fermé" },
  ];

  const BRANDS = ["Mindray", "Omron", "Spengler", "Camry"];

  // ==== Images locales (à placer dans /public/img/about/) ====
  const PUB = process.env.PUBLIC_URL || "";
  const IMGS = {
    hero: `${PUB}/img/about/hero.png`,
    warehouse: `${PUB}/img/about/warehouse.jpg`,
    installation: `${PUB}/img/about/installation.jpg`,
    equipment: `${PUB}/img/about/equipment.jpg`,
    team: `${PUB}/img/about/team.jpg`,
    mch1: `${PUB}/img/about/mch1.png`,
    mch2: `${PUB}/img/about/mch2.png`,
    mch3: `${PUB}/img/about/mch3.png`,
    galerie1: `${PUB}/img/about/galerie1.jpg`,
    galerie2: `${PUB}/img/about/galerie2.jpg`,
    galerie3: `${PUB}/img/about/galerie3.jpg`,
    galerie4: `${PUB}/img/about/galerie4.jpg`,
    galerie5: `${PUB}/img/about/galerie5.jpg`,

    // Parcours fondateur (exemples — remplace par tes fichiers)
    founder1: `${PUB}/img/about/founder1.jpeg`,
    founder2: `${PUB}/img/about/founder2.jpeg`,
    founder3: `${PUB}/img/about/founder3.jpg`,
    founder4: `${PUB}/img/about/founder4.jpg`,
    founder5: `${PUB}/img/about/founder5.jpg`,
    founderVid: `${PUB}/img/about/founder-formation.mp4`, // optionnel
  };

  // ==== Galerie (vignettes + lightbox) ====
  const GALLERY = [
    { src: IMGS.mch2, alt: "" },
    { src: IMGS.mch1, alt: "" },
    { src: IMGS.mch3, alt: "" },
    { src: IMGS.equipment, alt: "" },
    { src: IMGS.hero, alt: "" },
    { src: IMGS.galerie1, alt: "" },
    { src: IMGS.galerie2, alt: "" },
    { src: IMGS.galerie3, alt: "" },
    { src: IMGS.galerie4, alt: "" },
    { src: IMGS.galerie5, alt: "" },
  ];

  // ==== Parcours du fondateur (slider) ====
  const FOUNDER_STEPS = [
    { src: IMGS.founder1, year: "2015", place: "Lomé", caption: "Premières missions en laboratoire" },
    { src: IMGS.founder2, year: "2017", place: "Kpalimé", caption: "Installation d’équipements majeurs" },
    { src: IMGS.founderVid, year: "2019", place: "Atakpamé", caption: "Formation d’équipes (extrait vidéo)" },
    { src: IMGS.founder4, year: "2022", place: "Lomé", caption: "Déploiement en imagerie" },
    { src: IMGS.founder5, year: "2024", place: "Togo", caption: "Projet multi-sites" },
  ].filter((x) => !!x.src);

  const [galleryIndex, setGalleryIndex] = React.useState(0);
  const modalRef = React.useRef(null);
  const carouselRef = React.useRef(null);

  const openGallery = (i) => {
    setGalleryIndex(i);
    const modal = bootstrap.Modal.getOrCreateInstance(modalRef.current);
    modal.show();
    setTimeout(() => {
      const car = bootstrap.Carousel.getOrCreateInstance(carouselRef.current, {
        interval: 0,
        keyboard: true,
        ride: false,
      });
      car.to(i);
    }, 0);
  };

  React.useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;
    const onSlid = (e) => {
      if (typeof e.to === "number") setGalleryIndex(e.to);
    };
    el.addEventListener("slid.bs.carousel", onSlid);
    return () => el.removeEventListener("slid.bs.carousel", onSlid);
  }, []);

  // Liste des médias du slider 16:9 (images et/ou .mp4)
  const MEDIA = [
    { src: IMGS.equipment, alt: "Sélection de matériels et consommables" },
    { src: IMGS.mch1, alt: "Installation chez un client" },
    { src: IMGS.mch2, alt: "Préparation et stockage" },
    { src: IMGS.mch3, alt: "Équipe & support technique" },
    // { src: `${PUB}/img/about/overview.mp4`, alt: "Présentation vidéo" },
  ];

  // Utils visuels
  const PLACEHOLDER =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'>
         <defs>
           <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
            <stop offset='0%' stop-color='#f8f9fa'/>
            <stop offset='100%' stop-color='#eef1f4'/>
           </linearGradient>
         </defs>
         <rect width='100%' height='100%' fill='url(#g)'/>
         <text x='50%' y='50%' text-anchor='middle' dominant-baseline='middle'
           font-family='Arial' font-size='28' fill='#98a2ad'>Media en préparation</text>
       </svg>`
    );

  const onImgError = (e) => {
    e.currentTarget.src = PLACEHOLDER;
    e.currentTarget.style.objectFit = "contain";
    e.currentTarget.style.background = "#fff";
  };

  const isVideo = (u) => /\.mp4($|\?)/i.test(String(u || ""));

  return (
    <div className="container py-5">
      {/* BANNIÈRE VISUELLE */}
      <div className="mb-4">
        <div className="ratio ratio-21x9 rounded-4 overflow-hidden border">
          <img
            src={IMGS.hero}
            alt="MAMECHE — équipements & solutions"
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
            onError={onImgError}
          />
        </div>
      </div>

      {/* HERO TEXTE */}
      <div className="text-center mb-5">
        <h1 className="fw-bold">À propos de MAMECHE</h1>
        <p className="lead text-muted mt-2">
          Fournisseur d’équipements médico-chirurgicaux, consommables et réactifs de laboratoire.
        </p>
      </div>

      {/* INTRO + CONTACT */}
      <div className="row g-4 align-items-stretch mb-4">
        <div className="col-lg-7">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              {/* === SLIDER 16:9 “contain” === */}
              <div className="ratio ratio-16x9 rounded mb-3 overflow-hidden border">
                <div
                  id="aboutMediaCarousel"
                  className="carousel slide carousel-fade w-100 h-100"
                  data-bs-ride="carousel"
                  data-bs-interval="3000"
                  data-bs-pause="hover"
                >
                  {MEDIA.length > 1 && (
                    <div className="carousel-indicators">
                      {MEDIA.map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          data-bs-target="#aboutMediaCarousel"
                          data-bs-slide-to={i}
                          className={i === 0 ? "active" : ""}
                          aria-label={`Media ${i + 1}`}
                        />
                      ))}
                    </div>
                  )}

                  <div className="carousel-inner w-100 h-100">
                    {MEDIA.map((m, i) => {
                      const active = i === 0 ? "active" : "";
                      const video = isVideo(m.src);
                      return (
                        <div className={`carousel-item w-100 h-100 ${active}`} key={i}>
                          {video ? (
                            <video
                              className="w-100 h-100"
                              style={{ objectFit: "contain", background: "#fff" }}
                              playsInline
                              muted
                              loop
                              autoPlay
                              preload="metadata"
                              aria-label={m.alt}
                            >
                              <source src={m.src} type="video/mp4" />
                            </video>
                          ) : (
                            <img
                              src={m.src}
                              alt={m.alt}
                              className="w-100 h-100"
                              style={{ objectFit: "contain", background: "#fff" }}
                              onError={onImgError}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {MEDIA.length > 1 && (
                    <>
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#aboutMediaCarousel"
                        data-bs-slide="prev"
                      >
                        <span className="carousel-control-prev-icon" aria-hidden="true" />
                        <span className="visually-hidden">Précédent</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#aboutMediaCarousel"
                        data-bs-slide="next"
                      >
                        <span className="carousel-control-next-icon" aria-hidden="true" />
                        <span className="visually-hidden">Suivant</span>
                      </button>
                    </>
                  )}
                </div>
              </div>

              <h2 className="h5 fw-bold mb-3">Notre mission</h2>
              <p className="text-muted">
                Nous accompagnons hôpitaux, cliniques, laboratoires et industries avec des
                équipements fiables, conformes aux normes, et un support proche du terrain :
                conseil, disponibilité et suivi après-vente.
              </p>

              <div className="row g-3">
                <div className="col-sm-6">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold mb-1">Lignes de produits</div>
                    <ul className="small text-muted mb-0">
                      <li>Équipements médico-chirurgicaux</li>
                      <li>Mobilier & imagerie (échographes)</li>
                      <li>Consommables & pansements</li>
                      <li>Réactifs & tests rapides</li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold mb-1">Exemples récents</div>
                    <ul className="small text-muted mb-0">
                      <li>Tube EDTA (B/100)</li>
                      <li>Table d’examen pliable</li>
                      <li>Pèse-personne (cabinet/clinique)</li>
                      <li>Échographe (sondes convexe & endovaginale)</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="alert alert-success mt-3 mb-0">
                <strong>Engagement qualité :</strong> solutions fiables, références connues et
                accompagnement avant/après-vente.
              </div>
            </div>
          </div>
        </div>

        {/* COORDONNÉES + MAP */}
        <div className="col-lg-5">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h2 className="h5 fw-bold mb-3">Coordonnées</h2>

              <div className="mb-3">
                <div className="fw-semibold">Adresse</div>
                <div className="text-muted small">{ADDRESS}</div>
                <div className="d-flex gap-2 mt-2">
                  <a
                    className="btn btn-success btn-sm"
                    href={MAP_DIRECTIONS}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Itinéraire Google Maps
                  </a>
                  <a
                    className="btn btn-outline-secondary btn-sm"
                    href="mailto:contact@mameche.tg?subject=Demande%20d%E2%80%99information%20%E2%80%93%20MAMECHE"
                  >
                    Écrire un email
                  </a>
                </div>
              </div>

              <div className="mb-3">
                <div className="fw-semibold">Téléphones</div>
                <div className="d-flex flex-wrap gap-2">
                  {PHONES.map((p) => (
                    <a key={p.label} className="btn btn-outline-secondary btn-sm" href={p.href}>
                      {p.label}
                    </a>
                  ))}
                </div>
              </div>

              <div className="mb-3">
                <div className="fw-semibold">Horaires</div>
                <table className="table table-sm mb-0">
                  <tbody>
                    {HOURS.map((h) => (
                      <tr key={h.d}>
                        <td className="text-muted small" style={{ width: 130 }}>
                          {h.d}
                        </td>
                        <td className="small">{h.h}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="ratio ratio-4x3 rounded overflow-hidden border">
                <iframe
                  title="Carte MAMECHE"
                  src={MAP_EMBED}
                  loading="lazy"
                  style={{ border: 0 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GALERIE — vignettes cliquables */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h2 className="h5 fw-bold mb-3">Notre activité en images</h2>
          <div className="row g-3">
            {GALLERY.map((ph, i) => (
              <div className="col-6 col-md-4 col-lg-3" key={i}>
                <button
                  type="button"
                  className="p-0 border-0 bg-transparent w-100 text-start"
                  onClick={() => openGallery(i)}
                  aria-label={`Voir ${ph.alt || "l’image"}`}
                >
                  <div className="ratio ratio-4x3 rounded-3 overflow-hidden border cta-lift">
                    <img
                      src={ph.src}
                      alt={ph.alt}
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                      onError={onImgError}
                    />
                  </div>
                </button>
                {ph.alt && <div className="small text-muted mt-1">{ph.alt}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* PARCOURS DU FONDATEUR */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-stretch">
            {/* Slider */}
            <div className="col-lg-7">
              <div className="ratio ratio-16x9 rounded overflow-hidden border">
                <div
                  id="founderCarousel"
                  className="carousel slide carousel-fade w-100 h-100"
                  data-bs-ride="carousel"
                  data-bs-interval="3800"
                  data-bs-pause="hover"
                >
                  <div className="carousel-inner w-100 h-100">
                    {FOUNDER_STEPS.map((m, i) => (
                      <div className={`carousel-item w-100 h-100 ${i === 0 ? "active" : ""}`} key={i}>
                        {isVideo(m.src) ? (
                          <video
                            className="w-100 h-100"
                            style={{ objectFit: "contain", background: "#000" }}
                            playsInline
                            muted
                            loop
                            autoPlay
                            preload="metadata"
                            aria-label={`${m.year} — ${m.caption || ""}`}
                          >
                            <source src={m.src} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            src={m.src}
                            alt={`${m.year} — ${m.caption || ""}`}
                            className="w-100 h-100"
                            style={{ objectFit: "contain", background: "#fff" }}
                            onError={onImgError}
                          />
                        )}

                        {/* Badges overlay propres */}
                        <div className="carousel-caption d-none d-md-block text-start">
                          <span className="badge bg-success me-2">{m.year}</span>
                          {m.place && <span className="badge text-bg-dark">{m.place}</span>}
                          {m.caption && <div className="small mt-1">{m.caption}</div>}
                        </div>
                      </div>
                    ))}
                  </div>

                  {FOUNDER_STEPS.length > 1 && (
                    <>
                      <button className="carousel-control-prev" type="button" data-bs-target="#founderCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true" />
                        <span className="visually-hidden">Précédent</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#founderCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true" />
                        <span className="visually-hidden">Suivant</span>
                      </button>
                      <div className="carousel-indicators">
                        {FOUNDER_STEPS.map((_, i) => (
                          <button
                            key={i}
                            type="button"
                            data-bs-target="#founderCarousel"
                            data-bs-slide-to={i}
                            className={i === 0 ? "active" : ""}
                            aria-label={`Étape ${i + 1}`}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Timeline / légendes */}
            <div className="col-lg-5">
              <h2 className="h5 fw-bold mb-2">Parcours du fondateur</h2>
              <p className="text-muted small">
                Quelques jalons illustrés : installations, formations et déploiements réalisés au fil des années.
              </p>
              <ol className="list-unstyled small mb-0">
                {FOUNDER_STEPS.map((m, i) => (
                  <li key={i} className="d-flex align-items-start gap-2 mb-2">
                    <span className="badge bg-success rounded-pill">{m.year}</span>
                    <div>
                      <div className="fw-semibold">{m.caption || "Étape"}</div>
                      {m.place && <div className="text-muted">{m.place}</div>}
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* ÉQUIPE & VALEURS — moderne */}
      <div className="card card-neo shadow-sm mb-4">
        <div className="card-body">
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 mb-3">
            <h2 className="h5 fw-bold mb-0">Équipe & valeurs</h2>
            <div className="d-flex flex-wrap gap-2">
              {["Qualité", "Disponibilité", "Proximité client", "Transparence"].map((v) => (
                <span key={v} className="value-chip">
                  <i className="bi bi-check2-circle me-1"></i>{v}
                </span>
              ))}
            </div>
          </div>

          <div className="row g-3">
            {[
              { name: "Responsable Médical", role: "Conseil & spécifications", initials: "RM" },
              { name: "Responsable Industriel", role: "Solutions & déploiements", initials: "RI" },
              { name: "Support & Logistique", role: "Suivi commandes & SAV", initials: "SL" },
            ].map((m) => (
              <div className="col-12 col-md-4" key={m.name}>
                <div className="team-card h-100">
                  <div className="d-flex align-items-center gap-3">
                    <div className="avatar-ring" aria-hidden="true">
                      <div className="avatar-inner">{m.initials}</div>
                    </div>
                    <div>
                      <div className="fw-semibold">{m.name}</div>
                      <div className="small text-muted">{m.role}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MARQUES PARTENAIRES — moderne */}
      <div className="card card-neo shadow-sm mb-4">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 className="h5 fw-bold mb-0">Marques partenaires</h2>
            <small className="text-muted">Liste indicative selon disponibilité et projets</small>
          </div>

          {/* Noms seuls sur mobile */}
          <div className="d-flex flex-wrap gap-2 d-md-none">
            {BRANDS.map((b) => (
              <span key={b} className="brand-chip">{b}</span>
            ))}
          </div>

          {/* Grille logos (remplace span par <img className="brand-logo" /> si tu as des fichiers) */}
          <div className="row g-3 align-items-center d-none d-md-flex">
            {BRANDS.map((b) => (
              <div className="col-6 col-md-3 col-lg-2" key={b}>
                <div className="brand-tile">
                  <span className="brand-logo-text">{b}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SEO Organization */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            name: "MAMECHE",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Cité Maman N’DANIDA, à côté de la pharmacie de la Cité, Avénou",
              postalCode: "08 BP 8213 Lomé 08",
              addressLocality: "Lomé",
              addressCountry: "TG",
            },
            telephone: PHONES.map((p) => p.label),
            sameAs: [],
            openingHoursSpecification: HOURS.filter((h) => h.h.includes("—")).map((h) => {
              const [opens, closes] = h.h.split("—").map((s) => s.trim());
              return { "@type": "OpeningHoursSpecification", dayOfWeek: h.d, opens, closes };
            }),
          }),
        }}
      />

      {/* Lightbox galerie */}
      <div
        className="modal fade"
        id="aboutGalleryModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body p-0">
              <div className="ratio ratio-16x9 bg-white">
                <div
                  id="aboutGalleryCarousel"
                  className="carousel slide carousel-fade w-100 h-100"
                  data-bs-interval="0"
                  ref={carouselRef}
                >
                  <div className="carousel-inner w-100 h-100">
                    {GALLERY.map((ph, i) => (
                      <div
                        key={i}
                        className={`carousel-item w-100 h-100 ${i === galleryIndex ? "active" : ""}`}
                      >
                        <img
                          src={ph.src}
                          alt={ph.alt}
                          className="w-100 h-100"
                          style={{ objectFit: "contain", background: "#fff" }}
                          onError={onImgError}
                        />
                      </div>
                    ))}
                  </div>

                  {GALLERY.length > 1 && (
                    <>
                      <button className="carousel-control-prev" type="button" data-bs-target="#aboutGalleryCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true" />
                        <span className="visually-hidden">Précédent</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#aboutGalleryCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true" />
                        <span className="visually-hidden">Suivant</span>
                      </button>
                      <div className="carousel-indicators">
                        {GALLERY.map((_, i) => (
                          <button
                            key={i}
                            type="button"
                            data-bs-target="#aboutGalleryCarousel"
                            data-bs-slide-to={i}
                            className={i === galleryIndex ? "active" : ""}
                            aria-label={`Aller à l’image ${i + 1}`}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-between">
              <div className="small text-muted">
                {galleryIndex + 1} / {GALLERY.length}
              </div>
              <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
